// admin-ui/src/lib/replyActions.ts
export type ReplyActionView = {
  id: number
  index: number
  type: 'change_email' | 'resend_sign_in_link' | 'update_name' | 'update_address' | 'refund_charge' | 'stop_auto_renew'
  params: Record<string, string>
  reason: string | null
  status: 'proposed' | 'applying' | 'applied' | 'confirmation_sent' | 'confirmed' | 'refused' | 'failed' | 'skipped' | 'superseded'
  preflight: { verdict?: 'can_apply' | 'needs_confirmation' | 'needs_verification' | 'refused'; reason?: string }
  outcome: Record<string, unknown>
  verified_by: string | null
  error: string | null
  expected_text: string
}

export type ActionChoice = { index: number; skip: boolean; params?: Record<string, string>; staff_verified: boolean }

const MARKER = /\{\{action:(\d+)\}\}/g

export function markerProblems(body: string, keptIndexes: number[]): string[] {
  const counts: Record<number, number> = {}
  for (const m of body.matchAll(MARKER)) counts[Number(m[1])] = (counts[Number(m[1])] ?? 0) + 1
  return keptIndexes.filter((i) => counts[i] !== 1)
    .map((i) => `Put {{action:${i}}} back once where its result should go, or skip it.`)
}

export function previewBody(body: string, texts: Record<number, string>): string {
  return body.replace(MARKER, (_m, n) => texts[Number(n)] ?? '').replace(/[ \t]+\n/g, '\n').trim()
}

export const ACTION_TITLES: Record<ReplyActionView['type'], string> = {
  change_email: 'Change email',
  resend_sign_in_link: 'Resend sign-in link',
  update_name: 'Correct name',
  update_address: 'Correct postal address',
  refund_charge: 'Refund a payment',
  stop_auto_renew: 'Stop auto-renew',
}

/** The params staff may edit on each card; every action carries all keys, most of them empty. */
export const EDITABLE_PARAMS: Record<ReplyActionView['type'], string[]> = {
  change_email: ['new_email'],
  resend_sign_in_link: [],
  update_name: ['first_name', 'last_name'],
  update_address: ['address_1', 'address_2', 'city', 'state', 'zipcode', 'country'],
  refund_charge: ['amount', 'membership'],
  stop_auto_renew: [],
}

export const MEMBERSHIP_CHOICES: { value: string; label: string }[] = [
  { value: '', label: 'Default (end access on a full refund)' },
  { value: 'end_now', label: 'End access today' },
  { value: 'stop_renewal', label: 'Stop renewal, keep access to paid-through date' },
  { value: 'keep', label: 'Leave the membership as it is' },
]
